import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useTickets } from '../lib/ticket-state';
import { mobileTab } from '../lib/workflow';

const links = [
  {
    to: '/dashboard',
    label: 'Acasă',
    end: true,
    icon: <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m3 11 9-8 9 8" /><path d="M5 10v10h5v-6h4v6h5V10" /></svg>,
  },
  {
    to: '/tickets',
    label: 'Tichete',
    icon: <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16v5a2 2 0 0 0 0 4v5H4v-5a2 2 0 0 0 0-4V5Z" /><path d="M12 7v2m0 3v2m0 3v1" /></svg>,
  },
  {
    to: '/stock',
    label: 'Stoc',
    icon: <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 8 4v10l-8 4-8-4V7l8-4Z" /><path d="m4 7 8 4 8-4M12 11v10" /></svg>,
  },
  {
    to: '/reports',
    label: 'Rapoarte',
    icon: <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20V10M10 20V4M16 20v-6M22 20H2" /></svg>,
  },
];

export function Shell() {
  const { pathname } = useLocation();
  const { tickets, snapshotReady } = useTickets();
  // A progressively hydrated store is not an authoritative total.
  const activeCount = snapshotReady ? tickets.filter((ticket) => ['new', 'in_progress'].includes(mobileTab(ticket))).length : 0;
  const focusedTicketFlow = /^\/tickets\/[^/]+(?:\/(?:progress|close))?$/.test(pathname);
  return <div className={`app-shell${focusedTicketFlow ? ' app-shell--focused' : ''}`}>
    <main><Outlet /></main>
    {!focusedTicketFlow && <nav className="bottom-nav" aria-label="Navigare principală">
      {links.map((link) => <NavLink key={link.to} to={link.to} end={link.end} className="bottom-nav__item">
        <span className="bottom-nav__icon">{link.icon}{link.to === '/tickets' && activeCount > 0 && <b className="bottom-nav__badge">{activeCount > 99 ? '99+' : activeCount}</b>}</span>
        <span>{link.label}</span>
      </NavLink>)}
    </nav>}
  </div>;
}
